import request from "@/common/request.js";

export function MessageAdd(data) {
  return request({
    url: "/system/messages/add",
    method: "post",
    params: data,
  });
}
